import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFromArrayBy'
})
export class GetFromArrayByPipe implements PipeTransform {

  transform<T>(value: unknown, array: T[], key: keyof T): T {
    if (!array || !array.length) {
      return null;
    }
    return array.find(x => x[key] === value);
  }

}
